// Wrapper around the Ewen Realtors WordPress REST API
// Source: https://old.ewenrealtors.com/wp-json/wp/v2/

const WP_BASE = 'https://old.ewenrealtors.com/wp-json/wp/v2';

export const wpImage = (post) => {
  const media = post?._embedded?.['wp:featuredmedia']?.[0];
  return (
    media?.source_url ||
    post?.uagb_featured_image_src?.full?.[0] ||
    post?.uagb_featured_image_src?.large?.[0] ||
    post?.uagb_featured_image_src?.medium?.[0] ||
    null
  );
};

export const wpAuthor = (post) => post?._embedded?.author?.[0]?.name || 'Ewen Realtors';

export const wpCategories = (post) =>
  (post?._embedded?.['wp:term']?.[0] || []).map((t) => t.name).filter(Boolean);

export const wpReadTime = (post) => {
  const raw = (post?.content?.rendered || post?.excerpt?.rendered || '').replace(/<[^>]+>/g, ' ');
  const words = raw.split(/\s+/).filter(Boolean).length;
  const mins = Math.max(1, Math.round(words / 220));
  return `${mins} min`;
};

export const wpExcerpt = (post) => {
  const html = post?.uagb_excerpt || post?.excerpt?.rendered || '';
  return html.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
};

export const wpDate = (post) => {
  try {
    return new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
  } catch (_) {
    return '';
  }
};

async function req(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`WP request failed (${res.status})`);
  return res.json();
}

export async function listPosts({ perPage = 24, page = 1, search = '' } = {}) {
  const params = new URLSearchParams({ _embed: 'true', per_page: String(perPage), page: String(page) });
  if (search) params.set('search', search);
  return req(`${WP_BASE}/posts?${params.toString()}`);
}

export async function getPost(slug) {
  const params = new URLSearchParams({ _embed: 'true', slug });
  const items = await req(`${WP_BASE}/posts?${params.toString()}`);
  return items[0] || null;
}

export async function relatedPosts(post, limit = 3) {
  const categoryIds = post?.categories || [];
  const params = new URLSearchParams({ _embed: 'true', per_page: String(limit + 1), exclude: String(post.id) });
  if (categoryIds.length) params.set('categories', categoryIds.join(','));
  try {
    const items = await req(`${WP_BASE}/posts?${params.toString()}`);
    return items.slice(0, limit);
  } catch (_) {
    return [];
  }
}
